import React from 'react';
import { formatDateToDDMMYYYY_HHMMSS } from '../../../utils/formatDate';
import '../../../css/modal.css';

const MonitorModal = ({ show, row, onClose }) => {
  if (!show || !row) return null;
  return (
    <>
      <div
        className="modal-backdrop show"
        style={{ cursor: 'pointer', position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 1040 }}
      >
        {/* Fondo del modal */}
      </div>
      <div
        className="modal show"
        style={{ display: 'block', position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 1050, pointerEvents: 'none' }}
      >
        <div className="modal-dialog modal-xl modal-dialog-centered" style={{ pointerEvents: 'auto' }}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h5 className="modal-title">Estado documentos</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div style={{ marginBottom: '1em', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', alignItems: 'center', background: '#f8f9fa', borderRadius: '8px', padding: '12px 8px', fontSize: '16px', fontWeight: 500 }}>
                <div>
                  <span style={{color: '#14406e'}}><strong>Email colaborador</strong></span><br />
                  <span>{row.EmailColaborador ?? 'No disponible'}</span>
                </div>
                <div>
                  <span style={{color: '#14406e'}}><strong>En curso desde</strong></span><br />
                  <span>{row.created_at ? formatDateToDDMMYYYY_HHMMSS(row.created_at) : 'No disponible'}</span>
                </div>
              </div>
              {row.documentos && row.documentos.length > 0 ? (
                <div className="table-responsive modal-table-container">
                  <table className="table table-sm table-hover mb-0 modal-table">
                    <thead className="table-light sticky-top" style={{ top: 0, zIndex: 5 }}>
                      <tr>
                        <th>Documento</th>
                        <th>Jefe Remuneraciones</th>
                        <th>Jefe Inmediato</th>
                        <th>Colaborador</th>
                        <th>Recordatorio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {row.documentos.map((doc, idx) => (
                        <tr key={idx}>
                          <td>{doc.nombre_documento}</td>
                          <td>{doc.status_contrato.status_rrhh_texto}</td>
                          <td>{doc.status_contrato.status_jefe_inmediato_texto}</td>
                          <td>{doc.status_contrato.status_colaborador_texto}</td>
                          <td>{doc.status_contrato.fecha_recordatorio ? formatDateToDDMMYYYY_HHMMSS(doc.status_contrato.fecha_recordatorio) : ''}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>No hay documentos disponibles.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MonitorModal;
